/**
 * @ignore
 * @typedef {object} CustomEventOptions
 * @property {object} CustomEventOptions.detail - data passed when initializing the event
 * @property {boolean} CustomEventOptions.bubbles - A boolean indicating whether or not the event bubbles up through the DOM
 */

/**
 * @ignore
 * @private
 * @param {string} eventName - event name string to create a CustomEvent with
 * @param {CustomEventOptions} customEventOptions - options for creating
 * @returns {CustomEvent} a new CustomEvent
 */
export default function createCustomEvent(eventName, customEventOptions) {
  // NOTE - CustomEvent not supported in IE
  return new CustomEvent(eventName, customEventOptions);
}
